import { render, staticRenderFns } from "./china_dropdown.vue?vue&type=template&id=1afc2a98&scoped=true&"
import script from "./china_dropdown.vue?vue&type=script&lang=js&"
export * from "./china_dropdown.vue?vue&type=script&lang=js&"
import style0 from "./china_dropdown.vue?vue&type=style&index=0&id=1afc2a98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afc2a98",
  null
  
)

export default component.exports